import SupportIcon from '@raison/static/icons/customer-service-2-line.svg';
import {RootLayout, RsnPane} from '@raison/ui-kit';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router';
import {IntercomProvider, useIntercom} from 'react-use-intercom';
import {selectUserIsAuthorizedFlag} from '~/entities/user';
import {env} from '~/environment';
import {useIntercomUserInfo} from '../api/useIntercomUserInfo';

const {INTERCOM_APP_ID} = env;

export function SupportPage() {
    const navigate = useNavigate();
    return (
        <RootLayout title='Support' navigateBack={false}>
            <hgroup className={'flex flex-col gap-2 px-4 pb-2 pt-6'}>
                <h2 className={'fv-heading-l text-neutral-100'}>Choose support</h2>
                <p className={'fv-text-l-regular text-neutral-90'}>Select the best way to get help.</p>
            </hgroup>
            <RsnPane as='button' type='button' onClick={() => navigate('/support/form')}>
                <RsnPane.IconFrame>
                    <RsnPane.Icon src={SupportIcon} />
                </RsnPane.IconFrame>
                <RsnPane.TextBlock>
                    <RsnPane.PrimaryText>Support assistant</RsnPane.PrimaryText>
                    <RsnPane.SecondaryText>FAQ and chat</RsnPane.SecondaryText>
                </RsnPane.TextBlock>
                <RsnPane.Arrow />
            </RsnPane>
        </RootLayout>
    );
}

export function SupportFormPage() {
    const navigate = useNavigate();
    const navigateBack = () => navigate(-1);
    return (
        <RootLayout title='Support'>
            <IntercomProvider appId={INTERCOM_APP_ID} onHide={navigateBack}>
                <IntercomContainer />
            </IntercomProvider>
        </RootLayout>
    );
}

export namespace Intercom {
    export type UserInfo = {
        userId: string;
        email?: string;
        name?: string;
        userHash?: string;
        phone?: string;
        onboard_status?: string;
        plan?: string;
    };
}

function IntercomContainer() {
    const {boot, shutdown, show, isOpen} = useIntercom();
    const isAuthenticated = useSelector(selectUserIsAuthorizedFlag);
    const {data: intercomInfo} = useIntercomUserInfo({enabled: isAuthenticated});

    useEffect(() => {
        if (!isAuthenticated) {
            boot();
            show();
            return shutdown;
        } else if (intercomInfo) {
            boot(intercomInfo);
            show();
            return shutdown;
        }
    }, [isAuthenticated, intercomInfo]);

    return <div className='px-4 pb-7 pt-6'>{!isOpen && <div>Loading...</div>}</div>;
}
